/* tslint:disable:indent */
// Angular
import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {SmsService} from '../../../../services/sms-service';

@Component({
	selector: 'app-dialog-quick-sms',
	templateUrl: './dialog-quick-sms.component.html'
})
export class DialogQuickSmsComponent implements OnInit {

	defaultMaxLength: number = 500;
	smsPhone: string;
	smsBody: string;
	smsOriginator: string;


	constructor(
		public dialogRef: MatDialogRef<DialogQuickSmsComponent>,
		public smsService: SmsService,
		@Inject(MAT_DIALOG_DATA) public data: {
			fullName: string;
			phoneNumber: string
		}
	) { }

	ngOnInit() {
		this.smsPhone = this.data.phoneNumber;
		this.smsBody = '';
		this.smsOriginator = '';
	}

	onNoClick(): void {
		this.dialogRef.close(-1);
	}

	onYesClick(): void {
		this.smsService.sendSMS(this.smsOriginator, this.smsPhone, this.smsBody, false)
			.subscribe( (response: any) => {
		if (!response.error) {
			this.dialogRef.close(1);
		} else {
			this.dialogRef.close(0);
		}
	});
	}

}
